

import { SETTINGS_API } from "../constants/api";
import { getHeadersWithTokenOnly, getUrl, optionsGet } from "./commonService";
import customAxios from "./customAxios";

export default class SettingsService {

  getSettingsService(params: any) {

    const url = getUrl(SETTINGS_API.INFO);
    const headers = getHeadersWithTokenOnly(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

  getLocalNowService(params: any) {

    const url = getUrl(SETTINGS_API.LOCALNOW);
    const headers = getHeadersWithTokenOnly(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }
}
